import React from "react";
import { useStore } from "../../../store/store";

interface UpdateObj {
  equalPanels: boolean;
  exactConfigImg?: string;
}

function useEqualPanelsSelector(isPivot: boolean) {
  const addToQuote = useStore((state) => state.addToQuote);

  const equalPanels = useStore((state) => state.quote.equalPanels);

  const exactConfigImg = useStore((state) => state.quote.exactConfigImg);

  const handleErrMsgChange = useStore((state) => state.handleError);

  const checked = equalPanels ? true : false;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;

    let updateObj: UpdateObj = { equalPanels: checked };

    if (isPivot && exactConfigImg) {
      const configIMG =
        checked && !exactConfigImg.includes("LEVER")
          ? `${exactConfigImg.split(".jpg")[0]}_EVEN.jpg`
          : checked && exactConfigImg.includes("LEVER")
          ? `${exactConfigImg.split("_LEVER")[0]}_EVEN_LEVER.jpg`
          : exactConfigImg.replace("_EVEN", "");

      updateObj["exactConfigImg"] = configIMG;
    }

    handleErrMsgChange("swingWidthErr", "");
    addToQuote(updateObj);
  };

  return {
    handleChange,
    checked,
  };
}

export default useEqualPanelsSelector;
